/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrainingPaymentMode } from './TrainingPaymentMode';
import {
    TrainingPaymentModeFromJSON,
    TrainingPaymentModeFromJSONTyped,
    TrainingPaymentModeToJSON,
    TrainingPaymentModeToJSONTyped,
} from './TrainingPaymentMode';

/**
 * 
 * @export
 * @interface TrainingRecurringPaymentUpsertRequest
 */
export interface TrainingRecurringPaymentUpsertRequest {
    /**
     * 
     * @type {string}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    playerId: string;
    /**
     * 
     * @type {Date}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    billingPeriodStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    billingPeriodEnd: Date;
    /**
     * 
     * @type {Date}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    validFrom?: Date | null;
    /**
     * 
     * @type {TrainingPaymentMode}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    paymentMode: TrainingPaymentMode;
    /**
     * 
     * @type {number}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    expectedAmount?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    basePaid: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    baseAmountPaid?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    extraPaid: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    extraAmountPaid?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    amountPaid?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    paid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TrainingRecurringPaymentUpsertRequest
     */
    note?: string | null;
}



/**
 * Check if a given object implements the TrainingRecurringPaymentUpsertRequest interface.
 */
export function instanceOfTrainingRecurringPaymentUpsertRequest(value: object): value is TrainingRecurringPaymentUpsertRequest {
    if (!('playerId' in value) || value['playerId'] === undefined) return false;
    if (!('billingPeriodStart' in value) || value['billingPeriodStart'] === undefined) return false;
    if (!('billingPeriodEnd' in value) || value['billingPeriodEnd'] === undefined) return false;
    if (!('paymentMode' in value) || value['paymentMode'] === undefined) return false;
    if (!('basePaid' in value) || value['basePaid'] === undefined) return false;
    if (!('extraPaid' in value) || value['extraPaid'] === undefined) return false;
    return true;
}

export function TrainingRecurringPaymentUpsertRequestFromJSON(json: any): TrainingRecurringPaymentUpsertRequest {
    return TrainingRecurringPaymentUpsertRequestFromJSONTyped(json, false);
}

export function TrainingRecurringPaymentUpsertRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingRecurringPaymentUpsertRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'playerId': json['playerId'],
        'billingPeriodStart': (new Date(json['billingPeriodStart'])),
        'billingPeriodEnd': (new Date(json['billingPeriodEnd'])),
        'validFrom': json['validFrom'] == null ? undefined : (new Date(json['validFrom'])),
        'paymentMode': TrainingPaymentModeFromJSON(json['paymentMode']),
        'expectedAmount': json['expectedAmount'] == null ? undefined : json['expectedAmount'],
        'basePaid': json['basePaid'],
        'baseAmountPaid': json['baseAmountPaid'] == null ? undefined : json['baseAmountPaid'],
        'extraPaid': json['extraPaid'],
        'extraAmountPaid': json['extraAmountPaid'] == null ? undefined : json['extraAmountPaid'],
        'amountPaid': json['amountPaid'] == null ? undefined : json['amountPaid'],
        'paid': json['paid'] == null ? undefined : json['paid'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function TrainingRecurringPaymentUpsertRequestToJSON(json: any): TrainingRecurringPaymentUpsertRequest {
    return TrainingRecurringPaymentUpsertRequestToJSONTyped(json, false);
}

export function TrainingRecurringPaymentUpsertRequestToJSONTyped(value?: TrainingRecurringPaymentUpsertRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'playerId': value['playerId'],
        'billingPeriodStart': value['billingPeriodStart'].toISOString().substring(0,10),
        'billingPeriodEnd': value['billingPeriodEnd'].toISOString().substring(0,10),
        'validFrom': value['validFrom'] == null ? value['validFrom'] : value['validFrom'].toISOString().substring(0,10),
        'paymentMode': TrainingPaymentModeToJSON(value['paymentMode']),
        'expectedAmount': value['expectedAmount'],
        'basePaid': value['basePaid'],
        'baseAmountPaid': value['baseAmountPaid'],
        'extraPaid': value['extraPaid'],
        'extraAmountPaid': value['extraAmountPaid'],
        'amountPaid': value['amountPaid'],
        'paid': value['paid'],
        'note': value['note'],
    };
}

